import { render, staticRenderFns } from "./MyCafe.vue?vue&type=template&id=fe4813b0&"
import script from "./MyCafe.vue?vue&type=script&lang=js&"
export * from "./MyCafe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/hanmail/src/cafe-top/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('fe4813b0', component.options)
    } else {
      api.reload('fe4813b0', component.options)
    }
    module.hot.accept("./MyCafe.vue?vue&type=template&id=fe4813b0&", function () {
      api.rerender('fe4813b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/home/MyCafe.vue"
export default component.exports